module.exports = __webpack_public_path__ + "img/10.4.NH3-N.6995d053.png";